import {
  DialogContent,
  DialogContentProps,
  DialogTitle,
  Stack,
  StackProps,
} from '@mui/material';
import { MHMIconButton } from './MHMIconButton';
import { Close } from '@mui/icons-material';

type MHMDialogHeaderProps = {
  children: React.ReactNode;
  onClose(): void;
};

function Header({ onClose, children }: MHMDialogHeaderProps) {
  return (
    <Stack direction="row" alignItems="center" gap={2} pr={2}>
      <DialogTitle sx={{ mr: 'auto' }}>{children}</DialogTitle>
      <MHMIconButton size="medium" onClick={onClose}>
        <Close />
      </MHMIconButton>
    </Stack>
  );
}

type MHMDialogContentProps = {
  dividers?: DialogContentProps['dividers'];
} & StackProps;

const Content = (props: MHMDialogContentProps) => {
  const { dividers, ...rest } = props;
  const pt = dividers ? 2 : 0;
  return (
    <DialogContent dividers={dividers} sx={{ pt }}>
      <Stack gap={2} {...rest} />
    </DialogContent>
  );
};

export const MHMDialog = { Header, Content };
